"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ponte-nizza": {
    "8dbeeba3": [{
      "hkey": "209ea115",
      "slug": "sant-alberto-di-butrio",
      "name": "Sant'Alberto di Butrio",
      "primary": true,
      "skipSearch": false
    }],
    "s-alberto-di-butrio-panzini": [{
      "hkey": "209ea115",
      "slug": "sant-alberto-di-butrio",
      "name": "Sant'Alberto di Butrio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "49280937": [{
      "hkey": "209ea115",
      "slug": "sant-alberto-di-butrio",
      "name": "Sant'Alberto di Butrio",
      "primary": true,
      "skipSearch": false
    }],
    "s-alberto-di-butrio": [{
      "hkey": "209ea115",
      "slug": "sant-alberto-di-butrio",
      "name": "Sant'Alberto di Butrio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;